import { Injectable } from '@angular/core';
import { Http,Response, Headers,RequestOptions } from '@angular/http';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/first';
import 'rxjs/add/operator/catch';
import {Observable} from "rxjs";
import {ListaPrecio} from "../lista-precio/listaPrecio";
import {ListaPrecioDetalle} from "../lista-precio/listaPrecioDetalle";
import {AuthenticationService} from "../Login/authentication.service";
import {UrlService} from "./url.service";



@Injectable()
export class ListaPrecioService
{

  private headers = new Headers({'Content-Type':'application/json',
    'Authorization': 'Bearer ' + this.authenticationService.token  });//parametrizamos a json
  private options = new RequestOptions({ headers: this.headers });
  private url = this.URL.getLocal()+'/listaprecio';//Url que maeja GET ,POST
  private urlDetalleById = this.URL.getLocal()+'/productoprecio/';//busca un ListaPrecio por cedula
  private urlListaByTienda = this.URL.getLocal()+'/pos/';//busca los archivos de un ListaPrecio por id
  private urlDeleteFile = this.URL.getLocal()+'/listaprecio/archivo/eliminar/';//la direccion para borrar archivos
  private urlPut = this.URL.getLocal()+'/listaprecio/';//la direccion a la cual se conecta
  private urlPutDetalle = this.URL.getLocal()+'/productoprecio/actualizar';//la direccion a la cual se conecta


  //Constructor de la clase
  constructor(private URL:UrlService,private http:Http, private authenticationService: AuthenticationService)
  {
    //this.headers.append('Content-Type', 'application/x-www-form-urlencoded');
    //this.headers.append('X-Requested-With', 'XMLHttpRequest');
  }
  //Obtiene una lista de ListaPrecios
  getListaPrecio():Observable<ListaPrecio[]> {
    let url = `${this.url}`;
    return this.http.get(url,this.options)
      .map(r => r.json())
      .catch(this.handleError)
  }

  getListaByTienda(id: number): Observable<any[]> {
    let url = `${this.urlListaByTienda}${id}`;
    return this.http.get(url, this.options)
      .first()
      .map(r => r.json())
      .catch(this.handleError)
  }


  addListaPrecio(ListaPrecio:ListaPrecio) {
    let url = `${this.url}`;
    let iJson = JSON.stringify(ListaPrecio);
    return this.http.post(url,iJson,this.options)
      .map(r => r.json())
      .catch(this.handleError);

  }
  putListaPrecio(ListaPrecio : ListaPrecio,id:number){
    let url = `${this.urlPut}${id}`;
    let CJson = JSON.stringify(ListaPrecio);
    return this.http.put(url,CJson,this.options)
      .map(r => r.json())
      .catch(this.handleError);
  }

  getDetalleListaPrecio(id: number): Observable<any[]> {
    let url = `${this.urlDetalleById}${id}`;
    return this.http.get(url, this.options)
      .first()
      .map(r => r.json())
      .catch(this.handleError)
  }
  addListaPrecioDetalle(listaPrecioDetalle:ListaPrecioDetalle) {
    let url = `${this.url}`;
    let iJson = JSON.stringify(listaPrecioDetalle);
    return this.http.post(url,iJson,this.options)
      .map(r => r.json())
      .catch(this.handleError);

  }

  putListaPrecioDetalle(dato:any){
    let url = `${this.urlPutDetalle}`;
    let iJson = JSON.stringify(dato);
    return this.http.post(url,iJson,this.options)
      .map(r => r.json())
      .catch(this.handleError);
  }


//Este metodo detecta un error en la llamada a http
  private handleError(error : Response | any) {
    let errMsj : string;
    if(error instanceof Response)
    {
      let body  = error.json() || '';
      let err = body.error || JSON.stringify(body);
      errMsj = `${error.status} - ${error.statusText || ''} ${err}`;
    }
    else
    {
      errMsj = error.message ? error.message : error.Tostring();
    }
    return Observable.throw(errMsj);
  }
}



// WEBPACK FOOTER //
// H:/Proyectos Galeras Indie/Vinta/vinta Tinka/VintaWebClient/src/app/Services/listaPrecio.service.ts